import { render, staticRenderFns } from "./BindForm.vue?vue&type=template&id=fb55515e"
import script from "./BindForm.vue?vue&type=script&lang=js"
export * from "./BindForm.vue?vue&type=script&lang=js"
import style0 from "./BindForm.vue?vue&type=style&index=0&id=fb55515e&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports